import { ButtonAsLink, Container, Pending } from '@cluey/cluey-components';
import classNames from 'classnames';
import React, { ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { ArrowIcon } from '../../icons';
import { formatError } from '../../util/errors';
import { scrollToTop } from '../../util/helpers';
import withHeadTag from '../HeadComponent';

type CardLayoutProps = {
  className?: string;
  isLoading?: boolean;
  error?: unknown;
  children?: ReactNode;
  tracking?: string;
  customGoBack?: () => void;
  banner?: ReactNode;
};

const CardLayout = ({
  className,
  isLoading = false,
  error,
  children,
  tracking = null,
  customGoBack = null,
  banner,
}: CardLayoutProps) => {
  const history = useHistory();

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div
      className={classNames('flex min-h-screen flex-col', {
        [tracking]: tracking !== null,
      })}
    >
      <div className="border-b-2 border-grey-2 bg-blood-orange-1 py-10">
        <Container>
          <div className="px-4 pb-10">
            <ButtonAsLink
              className="mx-4 mb-5 p-0 lg:mx-0"
              onClick={() => {
                if (typeof customGoBack === 'function') {
                  customGoBack();
                } else {
                  history.goBack();
                }
              }}
            >
              <ArrowIcon className="-rotate-90 fill-blood-orange-4" width={24} height={24} />
            </ButtonAsLink>
            {banner}
            <div
              className={classNames('min-h-fit rounded-3xl bg-white px-10 py-8 shadow-lg lg:px-20 lg:py-14', className)}
            >
              <Pending loading={isLoading} error={error ? formatError(error) : undefined} loader={<Loader />}>
                <div className="flex flex-col lg:mb-0">{children}</div>
              </Pending>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default withHeadTag(CardLayout);
